import { render } from "./ShellModal.vue?vue&type=template&id=35c3a122&scoped=true"
import script from "../shells/ShellModal.js?vue&type=script&lang=js"
export * from "../shells/ShellModal.js?vue&type=script&lang=js"

import "./ShellModal.vue?vue&type=style&index=0&id=35c3a122&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c3a122"]])

export default __exports__